import styled from "styled-components";
import { Colors } from "../../../styles/colors";

export const Container = styled.div`
	background-color: #ffffff;
	height: 514px;
	width: 506px;
	border-radius: 30px;
	place-content: center;
	color: black;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
	position: relative;
	padding: 32px;


	.close {
		width: 1.738rem;

		position: absolute;
		right: 2rem;
		top: 2rem;

		cursor: pointer;
	}

	.alert {
		margin-bottom: 3rem;
		width: 12%;
	}

	.divText {
		width: 65%;
	}

	.text {
		color: #666666;
		font-weight: 400;
		font-family: Roboto;
		font-size: 1.625rem;
		line-height: 30.47px;
		text-align: center;
		margin-bottom: 2rem;

		b {
			color: #5c5b5b;
			font-weight: 500;
		}
	}

	.buttons {
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-top: 60px;
	}
	.desejaAtivar {
		text-align: center;
		font-size: 24px;
		font-weight: bold;
		color: #666666;
	}
	.pacientes {
		text-align: center;
		font-size: 24px;
		font-weight: bold;
		color: ${Colors.secondary_green_k_medium_1};
		margin-top: 20px;
	}

	.button {
		font-family: Roboto;
		font-size: 1.3rem;
		line-height: 1.758rem;

		color: #ffffff;

		width: 15rem;
		height: 5rem;

		border: 0;
		border-radius: 0.5rem;

		box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
	}

	.excluir {
		border: 3px solid ${Colors.secondary_green_k_medium_1};
		background: ${Colors.secondary_green_k_medium_1};
		transition: all 0.3s ease;
	}

	.excluir:hover {
		background: transparent;
		color: ${Colors.secondary_green_k_medium_1};
	}

	.cancelar {
		border: 3px solid #7f7f7f;
		background: #7f7f7f;
		transition: all 0.3s ease;
	}

	.cancelar:hover {
		background: transparent;
		color: #7f7f7f;
	}
`;

export const Button = styled.div`
	display: flex;
	width: 210px;
	height: 58px;
	justify-content: center;
	align-items: center;
	padding: 12px 32px;
	border-radius: 12px;
	border: 2px solid ${Colors?.primary_blue_k_main};
	cursor: pointer;
`;
